import { useState, useEffect, useCallback } from "react";
import { MultiSelector, MultiSelectorOption, SearchFunction } from "@/components/ui/multi-selector";
import { Plane } from "lucide-react";
import useFlightBookingStore from "@/lib/useFlightBookingStore";

// Default airlines for initial display
const DEFAULT_AIRLINES: MultiSelectorOption[] = [
  { label: "Air India (AI)", value: "AI", icon: Plane },
  { label: "IndiGo (6E)", value: "6E", icon: Plane },
  { label: "SpiceJet (SG)", value: "SG", icon: Plane },
];

interface AirlineSearchProps {
  onSelect: (airlines: {code: string}[]) => void;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  selectedAirline?: {code: string};
}

export function MultiAirlineSearch({
  selectedAirline,
  onSelect,
  disabled,
  className,
  placeholder = "Select Airlines...",
}: AirlineSearchProps) {
  const {
    searchAirlineSuggestions,
    airlineSearchSuggestions,
    isAirlineSearchSuggestionsLoading,
  } = useFlightBookingStore();




  // Create API search function for MultiSelector
  const apiSearchFunction: SearchFunction = useCallback(async (query: string) => {
    try {
      const suggestions = await searchAirlineSuggestions(query);
      // Convert AirlineSuggestion[] to MultiSelectorOption[]
      return suggestions.map((airline) => ({
        label: `${airline.name} (${airline.code})`,
        value: airline.code,
        icon: Plane,
      }));
    } catch (error) {
      console.error("Error searching airlines:", error);
      return [];
    }
  }, [searchAirlineSuggestions]);

  return (
    <MultiSelector
      options={DEFAULT_AIRLINES}
      onSearch={apiSearchFunction}
      onValueChange={onSelect}
      placeholder={placeholder}
      searchPlaceholder="Search Airlines..."
      variant="outline"
      maxCount={3}
      debounceDelay={300}
      minSearchLength={2}
      disabled={disabled}
      className={className}
      loading={isAirlineSearchSuggestionsLoading}
      maxHeight="200px"
    />
  );
}